/**
 * URL params component for filtering entries.
 * @returns {object} The URL params component.
 */
export default function urlParams() {
	return {
		loadFromUrlParams() {
			const urlParams = new URLSearchParams(window.location.search);

			const categories = urlParams.get("categories");
			if (categories) {
				this.selectedCategories = categories
					.split(",")
					.map((id) => parseInt(id))
					.filter((id) => !isNaN(id));
			}

			const topics = urlParams.get("topics");
			if (topics) {
				this.selectedTopics = topics
					.split(",")
					.map((id) => parseInt(id))
					.filter((id) => !isNaN(id));
			}

			const industries = urlParams.get("industries");
			if (industries) {
				this.selectedIndustries = industries
					.split(",")
					.map((id) => parseInt(id))
					.filter((id) => !isNaN(id));
			}

			const search = urlParams.get("search");
			if (search) {
				this.searchTerm = search;
			}

			const page = urlParams.get("page");
			if (page) {
				const pageNum = parseInt(page);
				if (!isNaN(pageNum) && pageNum > 0) {
					this.currentPage = pageNum;
				}
			}
		},

		updateUrlParams() {
			const params = new URLSearchParams();

			if (this.selectedCategories.length > 0) {
				params.set("categories", this.selectedCategories.join(","));
			}

			if (this.selectedTopics.length > 0) {
				params.set("topics", this.selectedTopics.join(","));
			}

			if (this.selectedIndustries.length > 0) {
				params.set("industries", this.selectedIndustries.join(","));
			}

			if (this.searchTerm) {
				params.set("search", this.searchTerm);
			}

			if (this.currentPage > 1) {
				params.set("page", this.currentPage.toString());
			}

			const newUrl =
				window.location.pathname +
				(params.toString() ? "?" + params.toString() : "");
			window.history.pushState({}, "", newUrl);
		},
	};
}
